import React, { useState } from 'react';

interface PromptTextPreviewProps {
  promptText: string;
}

const PREVIEW_CHARS = 420;

export const PromptTextPreview: React.FC<PromptTextPreviewProps> = ({ promptText }) => {
  const [expanded, setExpanded] = useState(false);
  const long = promptText.length > PREVIEW_CHARS;
  const shown =
    expanded || !long ? promptText : `${promptText.slice(0, PREVIEW_CHARS).trimEnd()}…`;

  return (
    <article className="prompt-col__card">
      <div className="prompt-col__block-head">
        <span className="explain__eyebrow">Your prompt</span>
        {long && (
          <button
            type="button"
            className="prompt-col__toggle"
            onClick={() => setExpanded((v) => !v)}
            aria-expanded={expanded}
          >
            {expanded ? 'Show less' : 'Show full text'}
          </button>
        )}
      </div>
      <div className="prompt-col__text-block">
        <pre className="prompt-col__text">{shown}</pre>
      </div>
    </article>
  );
};

export default PromptTextPreview;
